import React from 'react'

export const ChatFill = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    {...props}
  >
    <g clip-path='url(#clip0_2832_59819)'>
      <path
        d='M12 2C6.4772 2 2 6.47715 2 12C2 17.5228 6.4772 22 12 22H20C21.1046 22 22 21.1046 22 20V12C22 6.47715 17.5229 2 12 2ZM12 14H15C15.5523 14 16 14.4477 16 15C16 15.5523 15.5523 16 15 16H12C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14ZM9 10H15C15.5523 10 16 10.4477 16 11C16 11.5128 15.614 11.9355 15.1166 11.9933L15 12H9C8.4477 12 8 11.5523 8 11C8 10.4872 8.38603 10.0645 8.88338 10.0067L9 10Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_2832_59819'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='matrix(-1 0 0 1 24 0)'
        />
      </clipPath>
    </defs>
  </svg>
)
